const matchesLeinweberCustomerNumber = value => /^\d+$/.test(value) && value.length === 6;

export default matchesLeinweberCustomerNumber;
